import { Example } from './helpers/model';
import { SearchBox } from '@inmoment/the-kitchen';

// name the export <ReactComponentName_examples>
export const SearchBox_examples: Example<Parameters<typeof SearchBox>[0]>[] = [
  {
    name: 'Outline Pill',
    // props can be strings, numbers, or objects. Anything else will need to be custom
    props: {
      placeholder: 'Placeholder Text',
    },
    // angular: "my custom code" // If you want to use custom code for angular or react
  },
  {
    name: 'No Outline',
    props: {
      placeholder: 'Placeholder Text',
      outline: 'none',
    },
  },
];
